webpackJsonp([35783957827783],{

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _VVPSpecialVijfVragenAanBiancaDeGraaff = __webpack_require__(338);
	
	var _VVPSpecialVijfVragenAanBiancaDeGraaff2 = _interopRequireDefault(_VVPSpecialVijfVragenAanBiancaDeGraaff);
	
	var _cover = __webpack_require__(464);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Article = function (_React$Component) {
	  _inherits(Article, _React$Component);
	
	  function Article() {
	    _classCallCheck(this, Article);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Article.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'Main' },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner' },
	        _react2.default.createElement(
	          'a',
	          { href: _VVPSpecialVijfVragenAanBiancaDeGraaff2.default, className: 'Article-link' },
	          _react2.default.createElement('img', {
	            target: '_blank',
	            src: _cover2.default,
	            alt: 'VVP special Vijf vragen aan Bianca de Graaff cover'
	          }),
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'Article-linkHeader' },
	              'Lees het interview van VVP \xBB'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'Article-linkDescription' },
	              'Inspiratiemagazine voor financieel advies'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Article;
	}(_react2.default.Component);
	
	exports.default = Article;
	module.exports = exports['default'];

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    return _react2.default.createElement(
	      'footer',
	      { className: 'Footer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Split' },
	          _react2.default.createElement(
	            'div',
	            { className: 'Split-left' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'heading-dark' },
	              'Kennismaken? Meer weten?'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'phone' },
	                '0252 \u2013 22 25 25'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'divider' },
	                '|'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'email' },
	                'info@DeGraaffFinancieeladvies.nl'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'Main-sidebar Split-right' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'heading-caps' },
	              'Bezoekadres'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Parklaan 34A,',
	              _react2.default.createElement('br', null),
	              '2171 EE Sassenheim'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(66);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _deGraaffLogoKleur = __webpack_require__(128);
	
	var _deGraaffLogoKleur2 = _interopRequireDefault(_deGraaffLogoKleur);
	
	var _external = __webpack_require__(129);
	
	var _external2 = _interopRequireDefault(_external);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Header.prototype.render = function render() {
	    var isActive = false;
	    if (typeof window !== 'undefined') {
	      isActive = window.location.pathname.indexOf('nieuws') > -1;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'Header' },
	        _react2.default.createElement(
	          'div',
	          { className: 'inner' },
	          _react2.default.createElement(
	            'div',
	            { className: 'Header-left' },
	            _react2.default.createElement('img', {
	              className: 'Header-logo',
	              src: _deGraaffLogoKleur2.default,
	              alt: 'De Graaff Financieel Advies'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'Header-right' },
	            _react2.default.createElement(
	              'p',
	              { className: 'Header-p' },
	              _react2.default.createElement(
	                'span',
	                { className: 'phone' },
	                '0252 \u2013 22 25 25'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'divider' },
	                '|'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'email' },
	                'info@DeGraaffFinancieeladvies.nl'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'Nav' },
	        _react2.default.createElement(
	          'div',
	          { className: 'inner' },
	          _react2.default.createElement(
	            'nav',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { exact: true, activeClassName: 'active', to: '/' },
	              'Home'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '/nieuws/', className: isActive ? 'active' : null },
	              'Nieuws'
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://degraafffinancieeladvies.mijndigimap.nl/',
	                target: '_blank',
	                rel: 'noopener nofollow'
	              },
	              'Klantportaal',
	              _react2.default.createElement('img', { height: 12, src: _external2.default, 'aria-hidden': true })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _biancaDeGraaff = __webpack_require__(465);
	
	var _biancaDeGraaff2 = _interopRequireDefault(_biancaDeGraaff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hero = function (_React$Component) {
	  _inherits(Hero, _React$Component);
	
	  function Hero() {
	    _classCallCheck(this, Hero);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Hero.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'Hero' },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Hero-left' },
	          _react2.default.createElement('img', { className: 'Hero-photo', src: _biancaDeGraaff2.default, alt: 'Bianca De Graaff' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Hero-right' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'heading-yellow' },
	            _react2.default.createElement(
	              'em',
	              null,
	              'Onafhankelijk'
	            ),
	            ' Financieel Advies'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'text-white' },
	            'Wil je een huis kopen, je hypotheekrente verlengen, je financi\xEBn op orde brengen, besparen op je verzekeringen of heb je andere vragen?',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'b',
	              null,
	              'Wij kunnen je helpen.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'svg-container' },
	        _react2.default.createElement(
	          'svg',
	          { width: '1440px', viewBox: '0 0 1440 60' },
	          _react2.default.createElement(
	            'g',
	            { id: 'hero-bottom', fill: '#FFFFFF', fillRule: 'nonzero' },
	            _react2.default.createElement('path', {
	              d: 'M0,60 L0,0 C548.949848,1.26925875e-14 823.425766,59.241375 1440,59.241375 L1440,60 L0,60 Z',
	              id: 'Shape',
	              transform: 'translate(720.000000, 30.000000) scale(-1, 1) translate(-720.000000, -30.000000) '
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return Hero;
	}(_react2.default.Component);
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Header = __webpack_require__(76);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Hero = __webpack_require__(228);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Main = __webpack_require__(230);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Article = __webpack_require__(226);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Footer = __webpack_require__(227);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _PageEnd = __webpack_require__(231);
	
	var _PageEnd2 = _interopRequireDefault(_PageEnd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Homepage = function (_React$Component) {
	  _inherits(Homepage, _React$Component);
	
	  function Homepage() {
	    _classCallCheck(this, Homepage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Homepage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'Page' },
	      _react2.default.createElement(_Header2.default, null),
	      _react2.default.createElement(_Hero2.default, null),
	      _react2.default.createElement(_Main2.default, null),
	      _react2.default.createElement(_Article2.default, null),
	      _react2.default.createElement(_Footer2.default, null),
	      _react2.default.createElement(_PageEnd2.default, null)
	    );
	  };
	
	  return Homepage;
	}(_react2.default.Component);
	
	exports.default = Homepage;
	module.exports = exports['default'];

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Main = function (_React$Component) {
	  _inherits(Main, _React$Component);
	
	  function Main() {
	    _classCallCheck(this, Main);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Main.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'Main' },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Split' },
	          _react2.default.createElement(
	            'div',
	            { className: 'Split-left' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'heading-dark' },
	              'Adviseren ',
	              _react2.default.createElement(
	                'em',
	                null,
	                '&'
	              ),
	              ' Bemiddelen'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'We zijn onafhankelijk adviseur en hebben dus maar \xE9\xE9n belang: dat van jou.'
	              ),
	              ' ',
	              'We vergelijken verschillende banken en verzekeringsmaatschappijen met elkaar, totdat we de hypotheek of verzekering vinden die het beste bij jouw situatie past. Qua voorwaarden, maar zeker ook qua prijs.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Met een hypotheek- en/of verzekeringstraject helpen we je van de eerste stap tot de laatste.'
	              ),
	              ' ',
	              'Of het nu gaat om het contact met de notaris en makelaar, het regelen van een starterslening of het vergelijken van de verzekeringsvoorwaarden: wij regisseren het.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Wij zorgen dat alles draait en jij hoeft je alleen maar druk te maken over de inrichting van je huis of de kleur van je auto.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'aside',
	            { className: 'Main-sidebar Split-right' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Hoe we met je samenwerken'
	            ),
	            _react2.default.createElement(
	              'ol',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'We maken kennis'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'We inventariseren'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'We adviseren'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'We bemiddelen'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'We houden contact'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Main;
	}(_react2.default.Component);
	
	exports.default = Main;
	module.exports = exports['default'];

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deGraaffLogoWit = __webpack_require__(466);
	
	var _deGraaffLogoWit2 = _interopRequireDefault(_deGraaffLogoWit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageEnd = function (_React$Component) {
	  _inherits(PageEnd, _React$Component);
	
	  function PageEnd() {
	    _classCallCheck(this, PageEnd);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PageEnd.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'PageEnd' },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'PageEnd-left' },
	          _react2.default.createElement('img', {
	            style: { display: 'block' },
	            className: 'PageEnd-logo',
	            src: _deGraaffLogoWit2.default,
	            alt: 'De Graaff Financieel Advies'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'PageEnd-right' },
	          _react2.default.createElement(
	            'p',
	            { className: 'text-white' },
	            '2018 \xA9 De Graaff Financieel Advies'
	          )
	        )
	      )
	    );
	  };
	
	  return PageEnd;
	}(_react2.default.Component);
	
	exports.default = PageEnd;
	module.exports = exports['default'];

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/VVP special Vijf vragen aan Bianca de Graaff.a9f5a3ee.pdf";

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cover.c9277ecd.jpg";

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bianca-de-graaff.ec202716.jpg";

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/de-graaff-logo-kleur.1ff799b8.svg";

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/de-graaff-logo-wit.2aec1ee5.svg";

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAADwCAYAAACpBE5IAAAABmJLR0QA/wD/AP+gvaeTAAAEx0lEQVR4nO3dsY4bRxBF0SfB/+pPkMJytn/r0KGceDLZ1pLDru7iOcBLNplmzwUjApsAAAAAAAAAAAAAAAAAAAAAAAAAAAAzfUnyo/sQi31peu5Hkm9Nz34bX7sP8Ea+J/mj+xDTCXqtiqhfStDrVUT9MoLuURH1Swi6T0XUtxN0r4qobyXofhVR30bQe6iI+haC3kdF1E8T9F4qon6KoPdTEfXDBL2niqgfIuh9VUT9aYLeW0XUnyLo/VVE/csEfYaKqH+JoM9REfX/EvRZKqL+T4I+T0XU/0rQZ6qI+qcEfa6KqH/qx5ttmkr/ne609gMI+nmV/nvdZe0HEPQ9Kv13u8PaDyDo+1T677d77QcQ9L0q/Xcs6JUf+A1U+u9Z0Ks+8Juo9N+1oFd84DdS6b/vpfvtlmt7zO8/+dufC/72Tv7qPkAH35QzVTb4xmyYoAeq9IclaG5R6Y9K0Nyi0h9U9wQ9RKU/ph0m6AEq/SHtMkEfrtIf0U4T9MEq/QHtNkEfqtIfz44T9IEq/eHsOkEfptIfzc4T9EEq/cHsPkEfotIfywkT9AEq/aGcMkFvrtIfyUkT9MYq/YGcNkFvqtIfx4kT9IYq/WGcOkFvptIfxckT9EYq/UGcPkFvotIfw4QJegOV/hCmTNDNKv0RTJqgG1X6A5g2QTep9L/8iRN0g0r/i586QS9W6X/pkyfohSr9L3z6BL1Ipf9lv8MEvcC39L/olfv4Z4IeqNIf2MpV82cX9AtV+gPrirnrDgT9IpX+wLpj7rgLQb9ApT+wXWJefSeCvlmlP7DdYl55N4K+UaU/sF1jXnVHgr5JpT+w3WNecVeCvkGlP7BTYn71nQn6SZX+wE6L+VIvOJ+gn1DpD+zUmC918xkF/aBKf2Cnx3ypG88p6AdU+gObEvOlbjqroD+p0h/YtJgvdcN5Bf0Jlf7ApsZ8qQfOKegHdf0ksmMfN93ZI565Z0F/UqU/tlevbrqrZ1QEvUylP7rJMV8qgl6m0h/f5JgvFUEvU+mPcHLMl4qgl6n0xzg55ktF0MtU+qOcHPOlIuhlKv1xTo75UhH0MpX+SCfHfKkIeplKf6yTY75UBL1MpT/ayTFfKoJeptIf7+SYLxVBL1Ppj3hyzJeKoJepiHmFiqCX6fyVXuev5lb7SAS9SsU38xKCXqci5pcT9FoVMb+UoNeriPllBN2jIuaXEHSfiphvJ+heFTHfStD9KmK+jaD3UBHzLQS9j4qYnybovVTE/BRB76ci5ocJek8VMT9E0PuqiPlTvqQvri9Nzz3N9fPP762nOISgeZWWrr52PBReRdCMImhGETSjCJpRBM0ogmYUQTOKoBlF0IwiaEYRNKMImlEEzSiCZhRBM4qgGUXQjCJoRhE0owiaUQTNKIJmFEEziqAZRdCMImhGETSjCJpRBM0ogmYUQTOKoBlF0IwiaEYRNKMImlEEzSiCZhRBM4qgGUXQjCJoRhE0o3T+83q4nW9oRhE0owiaUQTNKIJmFEEziqAZRdCMImhGETSjCJpRBM0ogmYUQTOKoBlF0IwiaEYRNKMImlEEzSiCZhRBM4qgGUXQjCJoRhE0owiaUQTNKIIGAAAAAAAAAAAAAAAAAAAAAAAAAADgAH8DzbnLy5u4FWwAAAAASUVORK5CYII="

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(66);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Homepage = __webpack_require__(229);
	
	var _Homepage2 = _interopRequireDefault(_Homepage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(_Homepage2.default, null);
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-d5521cb3af9612b97007.js